export default {
  title: '404',
  subtitle: 'Page not found :(',
  description: 'This page does not exist in the application. But you can always go back to home',
  backButton: 'Home',
  nothingToShow: 'Nothing to show',
}